import {
    OrganizationContext
} from 'shared/context/OrganizationContext';
import {
    useContext,
    useState
} from 'react';
import ApiKeyManager from 'features/organizations/profile/apiKeyManager';
import {
    apiKeyService
} from 'shared/api';
import {
    Context
} from 'shared/context/GlobalState';

export default function WatsonApiKeys() {
    const {
        addNewNotifcation
    } = useContext(Context);
    const {
        selectedOrganization,
        actions
    } = useContext(OrganizationContext);
    const [loading, setLoading] = useState(false);

    const handleOnSubmit = async (value) => {
        if (!value.name || !value.url || !value.apiKey || !value.projectId) {
            throw new Error('Please fill all the fields');
        }

        setLoading(true);
        const apiKeyObj = {
            name: value.name,
            url: value.url.trim(),
            apiKey: value.apiKey.trim(),
            projectId: value.projectId.trim(),
            levelType: 'organization',
            levelId: selectedOrganization._id,
            apiType: 'IBM'
        };

        try {
            const apiKey = selectedOrganization.byoKeys.find((key) => key.apiType === 'IBM');
            let res;
            // check if update or create new
            if (apiKey && apiKey._id) {
                apiKeyObj.apiKeyId = apiKey._id;
                delete apiKeyObj.apiType;
                res = await apiKeyService.updateApiKeys(apiKeyObj);
                actions({
                    type: 'SET_SELECTED_ORGANIZATION',
                    payload: {
                        ...selectedOrganization,
                        byoKeys: [res.data]
                    }
                });
                addNewNotifcation('API Key updated successfully', 'success');
            } else {
                res = await apiKeyService.createNewApiKey(apiKeyObj);
                actions({
                    type: 'SET_SELECTED_ORGANIZATION',
                    payload: {
                        ...selectedOrganization,
                        byoKeys: [...selectedOrganization.byoKeys, res.data]
                    }
                });
                addNewNotifcation('API Key added successfully', 'success');
            }
        } catch (err) {

            addNewNotifcation('Something went wrong. Please try again', 'danger');
        } finally {
            setLoading(false);
        }
    };

    const handleOnDelete = async (value) => {
        const apiKeyDeleteObj = {
            byoKeyId: value._id,
            levelType: 'organization',
            levelId: selectedOrganization._id,
        };

        try {
            await apiKeyService.deleteApiKeys(apiKeyDeleteObj);
            actions({
                type: 'SET_SELECTED_ORGANIZATION',
                payload: {
                    ...selectedOrganization,
                    byoKeys: selectedOrganization.byoKeys.filter(item => item._id !== value._id)
                }
            });
        } catch (err) {

            if (err.response?.status === 409) {
                addNewNotifcation('API Key is in use. Please remove it from all channels before deleting', 'danger');
            }
        }
    };

    return (
        <div className='flex flex-grow flex-col mt-4'>
            <ApiKeyManager
                loading={loading}
                onSubmit={handleOnSubmit}
                apiKeys={selectedOrganization.byoKeys || []}
                onDelete={handleOnDelete}
            />
        </div>
    );
}
